import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../../../services/local-storage';
import { LoaderService } from '../../../services/Spinner.service';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupSegmentComponent } from '../../shared/components/popupAdmin/popup-segment.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-keywords',
    templateUrl: './advertisers.component.html',
  providers: [ SharedService,PopupSegmentComponent]
 
})
export class AdvertisersComponent implements OnInit {

data=[];
i=1;
page : number =1;
itemsTotalAdv : number =0;
enable = [];
objLoaderStatus: boolean = false;
blockedFlag : boolean = false;
searchAdvText = '';
message = '';
segmentArray =[];
errormessage = '';
charFlag :boolean = false;
userId : number;
searchmessage = "";

 column = "";
  numberColumn : number =0;
  order : string ="ASC";
  sortingOrder = [];
    constructor(private localstorage: LocalStorage,
     private loaderService: LoaderService,
    private formBuilder: FormBuilder,
    private shareService: SharedService,
    private PopupSegment: PopupSegmentComponent, 
    private dialogService:DialogService,
    private router: Router) {
var i=0;
  for(i=0;i<6;i++){
    this.sortingOrder[i] = true;
  }
    
    }

    ngOnInit() {
       this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });
this.localstorage.setStorage("country",'');
  var x= document.getElementById('id1');
       x.classList.toggle("submenuActive"); 

       var i=0;
         var token = this.localstorage.getStorage("token");
         this.loaderService.displayLoader(true);
  this.shareService.CallDatawithToken("admin/getAllAdvertiser?currentSize=25&sortColumn=MCE.name&sortOrder=ASC", null, token).subscribe((result) => {
  
  if(result.data){
      this.dataShowModulation(result.data);

this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
   this.loaderService.displayLoader(false);
  
}

     });
    }

nextAdver(text,id,order,event){
   var order;
  if(text){
  this.column = text;
}

if(this.column == ""){
  this.column = "MCE.name";
}
     if(id !== ''){
  this.numberColumn = id;
}

 var i=0;
  for(i=0;i<6;i++){
 
    if(this.numberColumn != i ){
    this.sortingOrder[i] = true;
  }
  }
if(order){
  this.order = order;
}
  
  

  if(this.order == 'DESC'){
this.sortingOrder[this.numberColumn] = false;
  }
  else{
this.sortingOrder[this.numberColumn] = true;
  }
    var j=0;
    this.page = event;
         var token = this.localstorage.getStorage("token");
this.searchAdvText = this.searchAdvText.trim();
    this.itemsTotalAdv =0;
  this.data =[];
   var i=0;
            this.errormessage ="";
this.searchmessage ="";
      if(this.blockedFlag == true){
      if((this.searchAdvText == '' || this.searchAdvText == undefined) ){
             this.loaderService.displayLoader(true);
this.shareService.CallDatawithToken("admin/getAllBlockedAdvertiser?currentSize=25&currentPage="+event+"&sortColumn="+this.column+"&sortOrder="+this.order, null, token).subscribe((result) => {
 if(result.data){
         this.dataShowModulation(result.data);

this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
 this.loaderService.displayLoader(false);
  }
   else{
      this.loaderService.displayLoader(false);

    //alert(result.meta.message);
  }
});
      }
       else{
       if(this.searchAdvText.length<2){
this.errormessage = "Please enter minimum 2 characters";
this.charFlag = true;
       }
       else{
           if(this.column == "MCE.name"){
           this.column = "CM.name";
         }
         else if(this.column == "contactNumber"){
this.column = "contact_Number";
         }
          else if(this.column == "businessAddress"){
this.column = "business_Address";
         }
         else if(this.column == ''){
           this.column = "CM.name";
         }
              this.loaderService.displayLoader(true);
      this.shareService.CallDatawithToken("admin/searchBlockedAdvertiser?currentSize=25&q="+this.searchAdvText+"&currentPage="+event+"&sortColumn="+this.column+"&sortOrder="+this.order, null, token).subscribe((result) => {
    if(result.data){
       if(result.data.length>0){
     this.dataShowModulation(result.data);
    
         this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
       }else{
          this.searchmessage = "No records found";
       }
        this.loaderService.displayLoader(false);
    }
      });  
    }
       }
    }
else if(this.searchAdvText == '' || this.searchAdvText == undefined){
                this.loaderService.displayLoader(true);
  this.shareService.CallDatawithToken("admin/getAllAdvertiser?currentSize=25&currentPage="+event+"&sortColumn="+this.column+"&sortOrder="+this.order, null, token).subscribe((result) => {
   if(result.data){
       this.dataShowModulation(result.data);

this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
 this.loaderService.displayLoader(false);
  
 }
    else{
       this.loaderService.displayLoader(false);
   // alert(result.meta.message);
  }
         });
        
}
 else{
   if(this.searchAdvText.length<2){
this.errormessage = "Please enter minimum 2 characters";
this.charFlag = true;
       }
       else{
         console.log(this.column);
         if(this.column == "MCE.name"){
           this.column = "CM.name";
         }
         else if(this.column == "contactNumber"){
this.column = "contact_Number";
         }
         else if(this.column == "businessAddress"){
this.column = "business_Address";
         }
         else if(this.column == ''){
           this.column = "CM.name";
         }
                       this.loaderService.displayLoader(true);
         this.shareService.CallDatawithToken("admin/searchAdvertiser?currentPage="+event+"&currentSize=25&q="+this.searchAdvText+"&sortColumn="+this.column+"&sortOrder="+this.order, null, token).subscribe((result) => {
         if(result.data){
            if(result.data.length>0){
       this.dataShowModulation(result.data);

this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
            }
            else{
          this.searchmessage = "No records found";
       }
 this.loaderService.displayLoader(false);
  
}
  else{
     this.loaderService.displayLoader(false);
    //alert(result.meta.message);
  }
       });   
         }
 }
    return event; 
    
        
}

getAllBlocked(){
      var i=0;
  for(i=0;i<6;i++){
    this.sortingOrder[i] = true;
  }
         this.column = "MCE.name";

       this.data = [];
       this.page =1;
      this.itemsTotalAdv =0;
      this.blockedFlag = true;
      this.searchAdvText = '';
       this.errormessage ="";
this.searchmessage ="";
    var token = this.localstorage.getStorage("token");
     this.loaderService.displayLoader(true);

  this.shareService.CallDatawithToken("admin/getAllBlockedAdvertiser?currentSize=25&sortColumn=MCE.name&sortOrder=ASC", null, token).subscribe((result) => {
    
    if(result.data){
      this.dataShowModulation(result.data);

this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
 this.loaderService.displayLoader(false);
  
}
   else{
   // alert(result.meta.message);
     this.loaderService.displayLoader(false);

  }
         });
  }

allAdver(){
    this.page = 1;
 var i=0;
  for(i=0;i<6;i++){
    this.sortingOrder[i] = true;
  }
         this.column = "MCE.name";

    var token = this.localstorage.getStorage("token");
  this.searchAdvText = '';
        this.itemsTotalAdv = 0;
 this.errormessage ="";
this.searchmessage ="";
   this.loaderService.displayLoader(true);
  this.shareService.CallDatawithToken("admin/getAllAdvertiser?currentSize=25&sortColumn=MCE.name&sortOrder=ASC", null, token).subscribe((result) => {
   if(result.data){
       this.dataShowModulation(result.data);

this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
 this.loaderService.displayLoader(false);
  
 }
    else{
       this.loaderService.displayLoader(false);
   // alert(result.meta.message);
  }
         });
}
   

      deleteAdvertiser(id){
        this.showConfirmDelete();
        this.userId = id;
     
   }

   viewActiveAdvertisements(id,name){
    
              this.router.navigate(['admin/advertisers/activeAdvertisement',{'id': id,'name': name}]);

   }

   

onChange(event,id){

   this.enable[id] = true;
   var token = this.localstorage.getStorage("token");
   if(event == true){
      
     this.loaderService.displayLoader(true);
this.shareService.callApiWithToken("admin/blockUser?userId="+id,{},token).subscribe((result) => {
  
    if(result.data && result.data.status == true){
         this.showblock();
this.enable[id] = true;
event = true;
}
    this.loaderService.displayLoader(false);
});

   }
   else{
    
     this.loaderService.displayLoader(true);
this.shareService.callApiWithToken("admin/unblockUser?userId="+id,{},token).subscribe((result) => {
    console.log(result.data);
  
    if(result.data && result.data.status == true){
      this.showunblock();
       // alert("Advertiser unblocked successfully");
;    
this.enable[id] = false;
event = false;
}
    this.loaderService.displayLoader(false);
});
  
   }

}

dataShowModulation(data){
var i=0
     for(i=0;i<data.length;i++){

   if(data[i].accountStatus == 'BLOCKED'){
this.enable[data[i].userId]= true;
    }
    else{
this.enable[data[i].userId]= false;
    }
 if(data[i].profileUrl && data[i].profileUrl.indexOf("user") == -1){
   data[i].profileUrl = "";
 }

  if(data[i].title && data[i].title == "MR"){
   data[i].title = "Mr";
 }
 else if(data[i].title && data[i].title == "MS"){
   data[i].title = "Ms";
 }
  else if(data[i].title && data[i].title == "MISS"){
   data[i].title = "Miss";
 }
  else if(data[i].title && data[i].title == "MRS"){
   data[i].title = "Mrs";
 }
  else if(data[i].title && data[i].title == "DR"){
   data[i].title = "Dr";
 }
}

 this.data = data;
}

viewSegments(id){
  var i=0;
  var j=0;
     this.segmentArray =[];
  for(i=0;i<this.data.length;i++){
 
    if(this.data[i].userId == id){
      console.log(this.data[i].segments);
      if(this.data[i].segments.length == 0){
        this.message = "No segments for this advertiser";
      }

      else{
             
        for(j=0;j<this.data[i].segments.length;j++){
        this.segmentArray = this.data[i].segments;
        this.message = "Information of Segments with this advertiser:";

      }
     console.log(this.segmentArray);
 
      }
    }
  }
this.showConfirm();

}


  showConfirm() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Advertiser Information', 
                message:this.message,
              data: this.segmentArray,
              showcancel :false})
                .subscribe((isConfirmed)=>{
                    //We get dialog result
                    
                });
            //We can close dialog calling disposable.unsubscribe();
            //If dialog was not closed manually close it by timeout
        }

          showunblock() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Advertiser Information', 
                message:'Advertiser Unblocked Successfully',
              data: [],
             showcancel :false})
                .subscribe((isConfirmed)=>{
                    //We get dialog result
                    
                });
        }

          showblock() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Advertiser Information', 
                message:'Advertiser Blocked Successfully',
              data: [],
             showcancel :false})
                .subscribe((isConfirmed)=>{
                    //We get dialog result
                    
                });
        }

          showDelete() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Advertiser Information', 
                message:'Advertiser Deleted Successfully',
              data: [],
             showcancel :false})
                .subscribe((isConfirmed)=>{
                    //We get dialog result
                    window.location.reload();
                });
        }

        showConfirmDelete(){
                  var token = this.localstorage.getStorage("token");

let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Advertiser Information', 
                message:'Are you sure you want to delete the advertiser?',
              data: [],
             showcancel :true})
                .subscribe((isConfirmed)=>{
                  if(isConfirmed){
                   this.loaderService.displayLoader(true);
this.shareService.callApiWithToken("admin/deleteUser?userId="+this.userId,{},token).subscribe((result) => {
    if(result.data.status == true){
      this.showDelete();
       // alert("Advertiser deleted successfully");
//window.location.reload();    }
    }
    this.loaderService.displayLoader(false);
});
                  }
                });

        }

}



// WEBPACK FOOTER //
// ./src/app/admin/layout/advertisers/advertisers.component.ts